// Group Insurance — audit trail viewer.
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

const ACTION_LABEL = (a) => (a || "").replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

export default function AuditPanel() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/insurance/admin/audit").then(r => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (!rows) return <Card className="p-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></Card>;

  return (
    <Card data-testid="gi-audit">
      <Table>
        <TableHeader>
          <TableRow><TableHead>When</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {!rows.length && <TableRow><TableCell colSpan={4} className="text-center py-8 text-sm text-muted-foreground">No audit entries yet.</TableCell></TableRow>}
          {rows.map(a => (
            <TableRow key={a.id} data-testid={`gi-audit-${a.id}`}>
              <TableCell className="text-xs whitespace-nowrap">{new Date(a.at).toLocaleString()}</TableCell>
              <TableCell className="text-xs">{a.actor}</TableCell>
              <TableCell className="text-xs font-semibold">{ACTION_LABEL(a.action)}</TableCell>
              <TableCell className="text-xs text-muted-foreground">{Object.entries(a.meta || {}).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
